import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  REQUEST_VALIDATE_MDS_CSV_TEMPLATE,
  SUCCESS_VALIDATE_MDS_CSV_TEMPLATE,
  FAILURE_VALIDATE_MDS_CSV_TEMPLATE,
  LOADING_VALIDATE_MDS_CSV_TEMPLATE,
} = therapyPlanningAction;

function* validateMdsAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_VALIDATE_MDS_CSV_TEMPLATE });
    const response = yield call(therapyPlanningService.validateCsvMdsFile, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_VALIDATE_MDS_CSV_TEMPLATE, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_VALIDATE_MDS_CSV_TEMPLATE, payload: error });
  }
}

function* validateMdsAssessmentSaga() {
  yield takeEvery(REQUEST_VALIDATE_MDS_CSV_TEMPLATE, validateMdsAssessment);
}

export default validateMdsAssessmentSaga;
